import { Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import SectionCard from "../../components/SectionCard";

export default function Denied() {
  return (
    <PageLayout>
      <SectionCard title="Oops!">
        <Typography sx={{ mb: 2 }}>
          It looks like you don't have permission to access this page or it
          doesn't exist. Try checking the URL or go back to the homepage.
        </Typography>
        <Typography component={RouterLink} to="/" className="inline-link">
          Go to homepage
        </Typography>
      </SectionCard>
    </PageLayout>
  );
}
